/* @flow */

import axios from 'axios';

let headers = {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    Apelido: global.Conexao.apelido,
};

if (global.Vars && global.Vars.sistema) {
    headers = {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Apelido: global.Conexao.apelido,
        Sistema: global.Vars.sistema.isB2b() ? 'B2B' : 'B2C',
    };
}

const xhrApiCs = axios.create({
    baseURL: 'https://apics.maxscalla.com.br',
    transformRequest: [JSON.stringify],
    headers,
    timeout: 30000,
    crossDomain: true,
});

xhrApiCs.interceptors.response.use(response => response.data);

export default xhrApiCs;



// WEBPACK FOOTER //
// ./app/admin/login/xhr-api-cs.js